import { v4 } from 'uuid';
import { EventDispatcher } from '../../events/event-dispatcher';
import { IComponent } from '../../shared/interfaces/components/component.interface';

export abstract class Component<M = any> extends EventDispatcher<M> implements IComponent {
    private readonly _uuid: string;
    protected readonly _container: JQuery;

    public constructor(container: JQuery) {
        super();

        this._uuid = v4();
        this._container = container;
    }

    public get container() {
        return this._container;
    }

    public get uuid() {
        return this._uuid;
    }

    protected _addEventListeners(): void {
    }

    public hide() {
        this._container.hide();
    }

    public show() {
        this._container.show();
    }
}
